<template>
  <section class="about">
    <div class="container">
      <img
        src="@/assets/images/truth-to-justice-logo--white.svg"
        width="282"
        alt="Logo"
        class="ttj-logo"
      />
      <p class="text">
        {{ $t("research.about.text") }}
      </p>
    </div>
  </section>
</template>

<style scoped>
.about {
  background-color: var(--color-primary);
  color: var(--color-off-white);

  padding-top: 3.75rem;
  padding-bottom: 3.75rem;
}

.container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
}
@media screen and (min-width: 1024px) {
  .container {
    flex-direction: row;
  }
}

.ttj-logo {
  margin: auto;
}

.text {
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 0;
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .text {
    width: 60%;
    max-width: 712px;
  }
}
</style>
